import React from "react";
import "./SecondaryOptionButtonStyles.scss";

type Props = {
    onClick: () => void;
    text: string;
};

export const SecondaryOptionButton: React.FC<Props> = (props: Props) => {
    return (
        <p className="secondary-option" onClick={props.onClick}>
            {props.text}
        </p>
    );
};
